import { render, staticRenderFns } from "./model-editor.vue?vue&type=template&id=52c0035f"
import script from "./model-editor.vue?vue&type=script&lang=ts"
export * from "./model-editor.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports